import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { projectKeys } from '../projectKeys'
import { checklistTemplateKeys } from '@core/react-query/features/templates/checklistTemplates'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useDeleteProjectChecklistTemplates = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['deleteProjectChecklistTemplate']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...projectKeys.deleteProjectChecklistTemplates,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(checklistTemplateKeys.getTemplates._def)
    },
  })
}
